'use client';

import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { Observer } from 'gsap/Observer';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

/**
 * THE single GSAP plugin registration point.
 *
 * Registering in each component that needs a plugin works, but it scatters
 * side effects across the bundle and makes it impossible to reason about what
 * runs on first paint. Everything imports `gsap` and the plugins from here.
 *
 * All of these plugins ship in the public `gsap` package as of 3.13 — no
 * Club membership, no private registry, no `.npmrc` token.
 */
let registered = false;

export function registerGsap(): void {
  // Plugins touch `window`/`document` at registration time.
  if (registered || typeof window === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger, Observer, SplitText, Flip);

  ScrollTrigger.config({
    // iOS/Android fire a resize when the URL bar collapses. Without this, every
    // such resize re-runs every ScrollTrigger's start/end calculation mid-scroll
    // and pinned sections visibly jump.
    ignoreMobileResize: true,
  });

  // If the main thread stalls for >500ms (a tab wake, a long task), don't let
  // gsap try to "catch up" by jumping time forward — clamp the delta instead.
  gsap.ticker.lagSmoothing(500, 33);

  registered = true;
}

export { gsap, ScrollTrigger, Observer, SplitText, Flip };
